import classNames from 'classnames';
import React from 'react';
import { PollsTabsOnMobile } from '../../../constans/polls-constants';
import './polls-mobile-navigation.scss';

interface IProps {
  activeTab: string;
  pollsCount: number;
  setActiveTab: (tab: string) => void;
  setShouldShowEllipsisMenu: (value: boolean) => void;
}

interface INavTab {
  name: PollsTabsOnMobile;
  text: string;
}

const PollsMobileNavigation: React.FC<IProps> = ({
  activeTab,
  pollsCount,
  setActiveTab,
  setShouldShowEllipsisMenu
}): JSX.Element => {
  const listTabText = `${PollsTabsOnMobile.LIST} (${pollsCount})`;

  const navigationTabs: INavTab[] = [
    {
      name: PollsTabsOnMobile.LIST,
      text: listTabText
    }, {
      name: PollsTabsOnMobile.DETAILS,
      text: PollsTabsOnMobile.DETAILS
    }
  ];

  const setActiveTabHandler = (tab: PollsTabsOnMobile): void => {
    setActiveTab(tab);
    setShouldShowEllipsisMenu(false);
  };

  return (
    <div className='polls-mobile-navigation'>
      {navigationTabs.map((el: INavTab) => {
        return (
          <div
            key={el.name}
            className={
              classNames('polls-mobile-navigation-tab',
                { active: activeTab === el.name })
            }
            onClick={setActiveTabHandler.bind(null, el.name)}
          >
            {el.text}
          </div>
        );
      })}
    </div>
  );
};

export default PollsMobileNavigation;
